module.exports = __webpack_public_path__ + "static/media/iPhone.1558672f.jpg";